import React from 'react';
import Header from '../../components/pteportal/Header';
import Footer from '../../components/pteportal/Footer';
import ClientFeedback from '../../components/pteportal/ClientFeedback';

import { Link} from 'react-router-dom';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import AOS from 'aos';
import ReactPixel from 'react-facebook-pixel';
import API, {base} from "api.js";
import { setAlert} from 'action/index.js';
import {store,persistor} from 'store/index';
import {
  Modal,
  ModalBody,
  ModalFooter
} from "reactstrap";
import SimpleReactValidator from 'simple-react-validator';
class Home extends React.Component {

    constructor(props) {
        AOS.init();
        super(props);
        this.state = {
            indexModal:false,
            name:"",
            phone:"",
            email:"",
            center:"",
            process:false
        }
        this.validator = new SimpleReactValidator();
    }
    componentDidMount() {
        if((store.getState().token)?false:true){
            setTimeout(() => { this.setState({indexModal:true}) }, 10000);
        }
        ReactGA.initialize('UA-157984080-1');
        ReactGA.pageview(window.location.pathname + window.location.search);
        ReactPixel.init('2474090032742391');
        ReactPixel.init('197333187452630');
        ReactPixel.pageView();
    }

    closeIndexModal = () =>{
        this.setState({indexModal:false});
    }

    changeInput = (e) => {
        let { name, value } = e.target;
        this.setState({ [name] : value });
    };

    postSubmit = async(e) => {

        if (!this.validator.allValid()) {
          this.validator.showMessages();
          this.forceUpdate();
          return false;
        }
        e.preventDefault();
        this.setState({process:true});
        var bodyFormData = new FormData();
        bodyFormData.append('phone', this.state.phone);
        bodyFormData.append('name', this.state.name);
        bodyFormData.append('email', this.state.email);
        bodyFormData.append('center', this.state.center);
        let res = null;
        try{
          res = await API({
            method: 'POST',
            url: '/submit-query',
            data: bodyFormData
          })
        }catch(error) {
            this.setState({process:false });
            return "l";
        };
        console.log(res);
        if (res.status === 200) {
          store.dispatch(setAlert({'flag':true,'type':1,'message':res.data.response.message,process:false}));
          this.setState({indexModal:false});       
        }else if (res.response.status === 422) {
          this.setState({error:res.response,process:false });
          let str = '';
          Object.values(this.state.error.data.errors).forEach((val) => { str += val[0]+'\n'; })
          this.setState({error_bag:str});
        }
    
    
  }
 render(){   
    return (
    <React.Fragment>
    <Helmet htmlAttributes>
        <title>Top PTE Training Institute In Parramatta | Best NAATI CCL Coaching Centre In Sydney</title>
        <meta name="twitter:title" content="Top PTE Training Institute In Parramatta | Best NAATI CCL Coaching Centre In Sydney" />
        <meta property="og:title" content="Top PTE Training Institute In Parramatta | Best NAATI CCL Coaching Centre In Sydney" />
        <meta name="description" content="Language Academy, being the top NAATI / PTE training institute in Parramatta, work with an aim of providing quality education to students at affordable prices and help them achieve their dream of permanent residency in Australia. To join the best PTE and NAATI coaching classes, contact us at info@languageacademy.com.au" />      
        
        <meta name="twitter:description" content="Language Academy, being the top NAATI / PTE training institute in Parramatta, work with an aim of providing quality education to students at affordable prices and help them achieve their dream of permanent residency in Australia. To join the best PTE and NAATI coaching classes, contact us at info@languageacademy.com.au" />
        <meta property="og:description" content="Language Academy, being the top NAATI / PTE training institute in Parramatta, work with an aim of providing quality education to students at affordable prices and help them achieve their dream of permanent residency in Australia. To join the best PTE and NAATI coaching classes, contact us at info@languageacademy.com.au" />      
      </Helmet>
    
  <section className="header-with-banner">
    <Header active="contact" />
    <section id="hero about-us-page" className="d-flex align-items-center">
      <div className="container position-relative" data-aos="fade-up" data-aos-delay="100">
        <div className="row justify-content-center">
          <div className="col-xl-12 col-lg-12 mb-5">
            <h2 className="main-heading pt-5 text-center">Contact Us</h2>
            <div className="breadcum">
              <ol className="breadcrumb primary-color text-center">
                  <li className="breadcrumb-item"><a className="white-text" href="#">Home</a></li>
                  <li className="breadcrumb-item active">Contact Us</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
    </section>

  <main id="main" className="avout-page">

    <section id="team" className="team section-bg">
      <div className="container" data-aos="fade-up">

        <div className="row">
          <div className="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
            <div className="member-box">
              <div className="member-img">
                <img src="/assets/img/phone.png" className="img-fluid" alt="" />
              </div>
              <div className="pehraraph mt-3">
                <p><b>Phone</b><br/>+61 426230061</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
            <div className="member-box">
              <div className="member-img">
                <img src="/assets/img/email.png" className="img-fluid" alt="" />
              </div>
              <div className="pehraraph mt-3">
                <p><b>Email </b><br/>Info@Pteportal.com</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
            <div className="member-box">
              <div className="member-img">
                <img src="/assets/img/location.png" className="img-fluid" alt="" />
              </div>
              <div className="pehraraph mt-3">
                <p><b>Address</b><br/>46 George Street, Parramatta</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 col-md-12 footer-links pt-5">
            <h2 className="banner-heading text-center pt-5">Have Some Questions</h2>
                <p className="text-center sub-quest-head">We'd love to help you</p>
              <div className="list-of-online">
              </div>
          </div>
          <div className="col-xl-6 col-lg-6 pt-5">
            <img src="/assets/img/msg.png" className="img-fluid" alt="" />
          </div>

          <div className="col-xl-6 col-lg-6 pt-5 text-center client-form contact-us">
            <div className="form-heading">
            </div>
            <form>
              <div className="form-group">
                <input type="text" className="form-control" placeholder="First Name" />
              </div>
              <div className="form-group">
                <input type="text" className="form-control" placeholder="Last Name" />
              </div>
              <div className="form-group">
                <input type="email" className="form-control" placeholder="What’s your Email?" />
              </div>
              <div className="form-group">
                <textarea className="form-control text-area-block" placeholder="Your Question" id="exampleFormControlTextarea1" rows="3"></textarea>
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-submit">Send Message</button>
              </div>
            </form>
          </div>
        </div>


      </div>
    </section>


    <section id="power-section" className="team section-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Take Scored PTE Mock Test <i><b>Free</b></i> Now</h2>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
            <div className="sign-box">
              <div className="sign-up-free">
                <button type="submit" className="btn btn-submit">Sign Up For Free</button>
              </div>
            </div>
          </div>
        </div>  
      </div>
    </section>

  </main>
  <Footer />
      
    </React.Fragment>);
    }
}

export default Home;